import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AUTHENTICATE_USER } from 'services/actions'
import { getJWT } from 'common/utils'
import { wrapper } from 'common/store'
import { urls } from 'common/routes'
import Modal from 'common/components/modal'
import {
  changeForgotPasswordFormField,
  forgotPasswordRequest,
  validateField,
} from 'page-modules/forgot-password/service/actions'
import AuthFooter from 'components/auth/footer'
import AuthFeature from 'components/auth/feature-container'
import Head from 'components/head'
import Form from 'common/components/form'
import lang from 'lang'

@connect(
  (state) => ({
    email: state.forgotPassword.formData.email,
    resetEmailSend: state.forgotPassword.resetEmailSend,
    loading: state.forgotPassword.loading,
    errors: state.forgotPassword.errors,
  }),
  (dispatch) => ({
    changeFormField: (key, value) => dispatch(changeForgotPasswordFormField(key, value)),
    forgotPasswordRequest: (requestData) => dispatch(forgotPasswordRequest(requestData)),
    validateField: (field, value, validations) =>
      dispatch(validateField(typeof field === 'string' ? { field, value, validations } : field)),
  }),
)
export default class ForgotPassword extends Form {
  static propTypes = {
    email: PropTypes.string,
    resetEmailSend: PropTypes.bool,
    loading: PropTypes.bool,
    forgotPasswordRequest: PropTypes.func,
    errors: PropTypes.object,
  }

  static getInitialProps = wrapper.getInitialPageProps((store) => ({ req, res }) => {
    if (req && req.headers.cookie) {
      const jwt = getJWT({ req })
      store.dispatch({ type: AUTHENTICATE_USER, payload: { jwt, res } })
    }
  })

  static validations = {
    email: 'nonEmpty email',
  }

  createForgotPasswordHandler() {
    return (e) => {
      e.preventDefault()
      this.props.forgotPasswordRequest({
        email: { value: this.props.email.trim(), validations: ForgotPassword.validations.email },
      })
    }
  }

  render() {
    return (
      <div>
        <Head title={lang.auth.forgottenPassword} />
        <Modal />
        <div className="main-auth-container">
          <div className="grid-x grid-padding-x align-center">
            <div className="small-11 medium-10 large-4 cell">
              <div className="auth-content">
                <header className="auth-header">
                  <div className="logo">
                    <a href={urls.login}>
                      <img
                        src="https://ruleronlineimgs.s3.amazonaws.com/logos/ruler-logo.svg"
                        alt="Ruler logo"
                      />
                    </a>
                  </div>
                  {this.props.resetEmailSend ? (
                    <h1 className="app-auth-title">{lang.auth.checkYourEmail}</h1>
                  ) : (
                    <h1 className="app-auth-title">{lang.auth.resetYourPassword}</h1>
                  )}
                </header>
                <main className="auth-main">
                  {this.props.resetEmailSend ? (
                    <p>
                      {lang.auth.checkYourEmailSubtitle}
                      <br />
                      {lang.thankYou}
                    </p>
                  ) : (
                    <>
                      <span className={cn('form-error', { 'is-visible': this.props.errors.base })}>
                        {this.props.errors.base}
                      </span>
                      <form action="" noValidate onSubmit={this.createForgotPasswordHandler()}>
                        <label htmlFor="e-mail">{lang.auth.emailLabel}</label>
                        <input
                          type="text"
                          id="e-mail"
                          value={this.props.email}
                          onChange={this.createFieldHandler('email')}
                          onBlur={this.createFieldValidationHandler(
                            'email',
                            ForgotPassword.validations.email,
                          )}
                          required
                          className={cn({ 'is-invalid-input': this.props.errors.email })}
                          pattern="email"
                        />
                        <span
                          className={cn('form-error', { 'is-visible': this.props.errors.email })}>
                          {this.props.errors.email}
                        </span>

                        <button
                          type="submit"
                          className="button expanded"
                          disabled={this.props.loading}>
                          {lang.auth.sendResetLink}
                        </button>
                      </form>
                    </>
                  )}
                </main>
                <AuthFooter />
              </div>
            </div>
          </div>
        </div>
        <AuthFeature />
      </div>
    )
  }
}
